import React from 'react'
import { useParams } from 'react-router-dom'

const ClassListProductsDetailPage = () => {
  const { id } = useParams()
  return <div>ClassListProductsDetailPage {id} </div>
}

export default ClassListProductsDetailPage
